import axios from "../http";

class Carrier {
  //获取承运商列表
  getExpressList(name) {
    const url = `/zwy/api/express/name/list?name=${name}`;
    return axios.get(url).then(res => {
      return Promise.resolve(res.data);
    });
  }
  //添加承运商
  postAddExpress(data) {
    const url = `/zwy/api/express/name/add`;
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data);
    });
  }
  //删除承运商
  postDeleteExpress(data) {
    const url = `/zwy/api/express/name/del`;
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data);
    });
  }
  //新增快递类型
  postAddExpressCarrier(data) {
    const url = `/zwy/api/express/carrier/add`;
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data);
    });
  }
}

export default Carrier;
